<template>
  <div>
    <Card title="First Time Subscription">
      <template v-slot:body>
        <div>
          <div class="pb-6 flex justify-between items-center">
            <div class="flex items-center">
              <div class="">
                <form-item label="Date">
                  <date-range-picker
                    ref="picker"
                    :timePicker="false"
                    :showDropdowns="false"
                    :max-date="maxDate"
                    v-model="dateRange"
                    :opens="'right'"
                    @update="onChangeDate"
                    :auto-apply="true"
                  >
                    <template v-slot:input="picker" >
                      From: {{ moment(picker.startDate) }} - To: {{ moment(picker.endDate) }}
                    </template>
                  </date-range-picker>
                </form-item>
              </div>
              <div class="">
                <form-item label="Search">
                  <el-input placeholder="search" v-model="filter.q" @change="searchMember" ></el-input>
                </form-item>
              </div>
              <div class="">
                <form-item label="Type">
                  <Select
                    filterable placeholder="Select Type"
                    v-model="filter.type"
                    :data="paymentTypes"
                    @change="searchMember"
                  />
                </form-item>
              </div>
              <div class="">
                <form-item label="Free Trial?">
                  <Select
                    filterable placeholder="Free Trial?"
                    v-model="filter.free_trial"
                    :data="freeTrialTypes"
                    @change="searchMember"
                  />
                </form-item>

              </div>
            </div>
            <div>
              <div @click="download" class="flex justify-center p-4 bg-blue-200 rounded-lg shadow-xs cursor-pointer text-xs">
                Download
              </div>
            </div>
          </div>
          <div class="pb-3 flex" style="gap: 16px;">
            <card-stats
              statSubtitle="First Time Subscriber"
              :statTitle="totalFirstTime"
              stat-icon-name="fa fa-users"
              class-name="w-1/3"
            />
            <card-stats
              statSubtitle="New Free Trial"
              :statTitle="totalFreeTrial"
              stat-icon-name="fa fa-users"
            />
            <card-stats
              statSubtitle="One-Time"
              :statTitle="totalOneTime"
              stat-icon-name="fa fa-users"
            />
          </div>
          <div class="pb-6 flex" style="gap: 16px;">
            <card-stats
              statSubtitle="Recurring"
              :statTitle="totalRecurring"
              stat-icon-name="fa fa-users"
            />
            <card-stats
              statSubtitle="Total Amount"
              :statTitle="`$${totalAmount}`"
            />
          </div>
        </div>
        <data-tables-server ref="tableRating" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [20,50,100,300,500] }" @query-change="onChangeTable" >
          <el-table-column v-for="title in titles" :prop="title.prop.field" :label="title.label" :key="title.prop.field" sortable="custom">
          </el-table-column>
        </data-tables-server>
      </template>
    </Card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import fileDownload from 'js-file-download';
import axios from 'axios';
import { authHeader2 } from '@/helper/authHeader';
import { Button, FormItem, Select } from '@/components/Layout/Form';
import Card from '@/components/Layout/Card.vue';
import CardStats from '@/components/Layout/CardStats.vue';

const API_URL = process.env.API_URL;

export default {
  name: 'FirstTimeSubs',
  data() {
    return {
      isLoading: false,
      utc_offset: Math.floor(moment().utcOffset() / 60),
      data: [],
      total: 0,
      totalFirstTime: 0,
      totalFreeTrial: 0,
      totalAmount: 0,
      totalOneTime: 0,
      totalRecurring: 0,
      displayingItem: 20,
      titles: [
        {
          prop: {
            field: 'name',
          },
          label: 'Name',
        },
        {
          prop: {
            field: 'email',
          },
          label: 'Email',
        },
        {
          prop: {
            field: 'payment_method',
          },
          label: 'Payment Method',
        },
        {
          prop: {
            field: 'amount',
          },
          label: 'Amount',
        },
        {
          prop: {
            field: 'currency',
          },
          label: 'Currency',
        },
        {
          prop: {
            field: 'type',
          },
          label: 'Type',
        },
        {
          prop: {
            field: 'country_name',
          },
          label: 'Country',
        },
        {
          prop: {
            field: 'transaction_date',
          },
          label: 'Transaction Date',
        },
      ],
      filter: {
        page: 1,
        per_page: 20,
        q: '',
        type: 'all',
        free_trial: 0,
        start_date: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
        sortby: 'transaction_date',
        sortorder: 'desc',
      },
      dateRange: {
        startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      },
      maxDate: moment().format('YYYY-MM-DD'),
      paymentTypes: [
        {
          value: 'all',
          label: 'All Types',
        },
        {
          value: 'recurring',
          label: 'Recurring',
        },
        {
          value: 'one_time',
          label: 'One Time',
        },
      ],
      freeTrialTypes: [
        {
          value: 0,
          label: 'No',
        },
        {
          value: 1,
          label: 'Yes',
        },
      ]
    };
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListFirstTimeSubs(this.filter);
  },
  computed: {
    ...mapGetters('AuthModule', ['isSuperAdmin', 'isAdmin', 'isOps', 'isFinance']),
    ...mapGetters('SubscriptionModule', ['list_first_time', 'total_first_time']),
  },
  watch: {
    total_first_time: {
      immediate: true,
      async handler(val) {
        this.totalFirstTime = val.total_first_time || 0;
        this.totalFreeTrial = val.total_free_trial || 0;
        this.totalOneTime = val.total_first_time_one_time || 0;
        this.totalAmount = val.total_amount || 0;
        this.totalRecurring = val.total_first_time_recurring || 0;
      },
    },
    list_first_time: {
      immediate: true,
      async handler(val) {
        if (val.data) {
          await this.refineData();
        }
      },
    },
  },
  methods: {
    ...mapActions('SubscriptionModule', ['requestListFirstTimeSubs']),
    moment(date, withTime = false) {
      return moment(date).format(`YYYY-MM-DD ${withTime ? 'HH:mm:ss':''}`);
    },
    filterFormatUtc(params){
      const startUtc = moment(this.filter.start_date).utc().format('YYYY-MM-DD HH:mm:ss');
      const endUtc = moment(this.filter.end_date).utc().format('YYYY-MM-DD HH:mm:ss');
      return {
        ...this.filter,
        ...params,
        start_date: startUtc,
        end_date: endUtc,
      }
    },
    async searchMember() {
      this.filter.page = 1;

      await this.requestListFirstTimeSubs(this.filterFormatUtc({}));
    },
    async resetMember() {
      this.$refs.tableRating.$refs.elTable.clearSort();
      this.filter.page = 1;
      this.filter.q = '';
      await this.requestListFirstTimeSubs(this.filterFormatUtc({}));
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const page = queryInfo.page;
      const pageSize = queryInfo.pageSize;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order;
      if (typeof (sortorder) === 'undefined') {
        sortorder = 'desc';
      } else {
        sortorder = queryInfo.sort.order === 'ascending' ? 'asc' : 'desc';
      }
      if (typeof (sortby) === 'undefined') {
        sortby = 'transaction_date';
      }
      this.filter = Object.assign(this.filter, { page, sortby, sortorder, per_page: pageSize });
      await this.requestListFirstTimeSubs(this.filterFormatUtc({}));
    },
    refineData() {
      this.data = this.list_first_time.data.map((val) => {
        return { ...val,
          payment_method: this.getChannelName(val.payment_method),
          transaction_date: this.moment(val.transaction_date,true)
        };
      });
      this.total = this.list_first_time.total_data;
    },
    async onChangeDate(res) {
      this.filter = { ...this.filter,
        start_date: moment(res.startDate).format('YYYY-MM-DD'),
        end_date: moment(res.endDate).format('YYYY-MM-DD'),
      };
      await this.searchMember();
    },
    getChannelName(key){
      if(key === null || key === ""){
        return 'Credit Card'
      }else{
        switch (key) {
          case 'credit':
            return 'Credit'
          case 'wechat':
            return 'Wechat'
          case 'grab_pay':
            return 'Grab Pay'
          case 'gcash':
            return 'GCash'
          case 'in-app':
            return 'In App'
          case 'applepay':
            return 'Apple Pay'
          case 'apple_pay':
            return 'Apple Pay'
          default:
            return key
        }
      }
    },
    download(){
      axios({
        url: `${API_URL}/admin/subscription/report-by-type/download`,
        method: 'get',
        params: this.filter,
        headers:  authHeader2(),
        responseType: 'blob',
      }).then(res => {
        fileDownload(res.data, 'report_cancel_expire.csv');
      }).catch((err) => {
        throw err.response;
      });
    }
  },
  components: {
    VueCustomTooltip,
    DateRangePicker,
    Button,
    Card,
    Select,
    FormItem,
    CardStats
  },
};
</script>
<style>
.daterangepicker .calendars{
  display:flex !important;
}
</style>
<style scoped>
.z-1000{
  z-index: 1000;
}
.mx-400{
  max-height: 50%;
  height: 50vh;
}
</style>



// WEBPACK FOOTER //
// src/views/Subscription/FirstTimeSubs.vue